import { render, staticRenderFns } from "./ProjectStateUpdate.vue?vue&type=template&id=acb88630&"
import script from "./ProjectStateUpdate.vue?vue&type=script&lang=js&"
export * from "./ProjectStateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports